module.exports = __webpack_public_path__ + "img/firework_left_1.9ae55d9e.png";